import { jsxs as Be, jsx as P } from "react/jsx-runtime";
import j, { useRef as A, useMemo as E, useLayoutEffect as zn, useEffect as N, useCallback as $, useState as K, memo as Bn, useReducer as Pn, createContext as Ue, useContext as be } from "react";
import { unstable_batchedUpdates as et, createPortal as $n } from "react-dom";
function Fn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return E(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const lt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Re(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function Rt(e) {
  return "nodeType" in e;
}
function X(e) {
  var t, n;
  return e ? Re(e) ? e : Rt(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function It(e) {
  const {
    Document: t
  } = X(e);
  return e instanceof t;
}
function He(e) {
  return Re(e) ? !1 : e instanceof X(e).HTMLElement;
}
function en(e) {
  return e instanceof X(e).SVGElement;
}
function Ie(e) {
  return e ? Re(e) ? e.document : Rt(e) ? It(e) ? e : He(e) || en(e) ? e.ownerDocument : document : document : document;
}
const re = lt ? zn : N;
function Et(e) {
  const t = A(e);
  return re(() => {
    t.current = e;
  }), $(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function jn() {
  const e = A(null), t = $((r, o) => {
    e.current = setInterval(r, o);
  }, []), n = $(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function je(e, t) {
  t === void 0 && (t = [e]);
  const n = A(e);
  return re(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function Ke(e, t) {
  const n = A();
  return E(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function ot(e) {
  const t = Et(e), n = A(null), r = $(
    (o) => {
      o !== n.current && t?.(o, n.current), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
function yt(e) {
  const t = A();
  return N(() => {
    t.current = e;
  }, [e]), t.current;
}
let vt = {};
function Ve(e, t) {
  return E(() => {
    if (t)
      return t;
    const n = vt[e] == null ? 0 : vt[e] + 1;
    return vt[e] = n, e + "-" + n;
  }, [e, t]);
}
function tn(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return r.reduce((i, s) => {
      const a = Object.entries(s);
      for (const [l, c] of a) {
        const d = i[l];
        d != null && (i[l] = d + e * c);
      }
      return i;
    }, {
      ...t
    });
  };
}
const Se = /* @__PURE__ */ tn(1), Xe = /* @__PURE__ */ tn(-1);
function Xn(e) {
  return "clientX" in e && "clientY" in e;
}
function At(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = X(e.target);
  return t && e instanceof t;
}
function Wn(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = X(e.target);
  return t && e instanceof t;
}
function xt(e) {
  if (Wn(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return Xn(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const We = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [We.Translate.toString(e), We.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), Xt = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Yn(e) {
  return e.matches(Xt) ? e : e.querySelector(Xt);
}
const Un = {
  display: "none"
};
function Hn(e) {
  let {
    id: t,
    value: n
  } = e;
  return j.createElement("div", {
    id: t,
    style: Un
  }, n);
}
function Kn(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const o = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return j.createElement("div", {
    id: t,
    style: o,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function Vn() {
  const [e, t] = K("");
  return {
    announce: $((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const nn = /* @__PURE__ */ Ue(null);
function qn(e) {
  const t = be(nn);
  N(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function Gn() {
  const [e] = K(() => /* @__PURE__ */ new Set()), t = $((r) => (e.add(r), () => e.delete(r)), [e]);
  return [$((r) => {
    let {
      type: o,
      event: i
    } = r;
    e.forEach((s) => {
      var a;
      return (a = s[o]) == null ? void 0 : a.call(s, i);
    });
  }, [e]), t];
}
const Jn = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, _n = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function Qn(e) {
  let {
    announcements: t = _n,
    container: n,
    hiddenTextDescribedById: r,
    screenReaderInstructions: o = Jn
  } = e;
  const {
    announce: i,
    announcement: s
  } = Vn(), a = Ve("DndLiveRegion"), [l, c] = K(!1);
  if (N(() => {
    c(!0);
  }, []), qn(E(() => ({
    onDragStart(u) {
      let {
        active: h
      } = u;
      i(t.onDragStart({
        active: h
      }));
    },
    onDragMove(u) {
      let {
        active: h,
        over: f
      } = u;
      t.onDragMove && i(t.onDragMove({
        active: h,
        over: f
      }));
    },
    onDragOver(u) {
      let {
        active: h,
        over: f
      } = u;
      i(t.onDragOver({
        active: h,
        over: f
      }));
    },
    onDragEnd(u) {
      let {
        active: h,
        over: f
      } = u;
      i(t.onDragEnd({
        active: h,
        over: f
      }));
    },
    onDragCancel(u) {
      let {
        active: h,
        over: f
      } = u;
      i(t.onDragCancel({
        active: h,
        over: f
      }));
    }
  }), [i, t])), !l)
    return null;
  const d = j.createElement(j.Fragment, null, j.createElement(Hn, {
    id: r,
    value: o.draggable
  }), j.createElement(Kn, {
    id: a,
    announcement: s
  }));
  return n ? $n(d, n) : d;
}
var M;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(M || (M = {}));
function it() {
}
function pt(e, t) {
  return E(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function Zn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return E(
    () => [...t].filter((r) => r != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const Q = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function rn(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function on(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return n - r;
}
function er(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: r
    }
  } = t;
  return r - n;
}
function Wt(e) {
  let {
    left: t,
    top: n,
    height: r,
    width: o
  } = e;
  return [{
    x: t,
    y: n
  }, {
    x: t + o,
    y: n
  }, {
    x: t,
    y: n + r
  }, {
    x: t + o,
    y: n + r
  }];
}
function sn(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return n[t];
}
function Yt(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const tr = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const o = Yt(t, t.left, t.top), i = [];
  for (const s of r) {
    const {
      id: a
    } = s, l = n.get(a);
    if (l) {
      const c = rn(Yt(l), o);
      i.push({
        id: a,
        data: {
          droppableContainer: s,
          value: c
        }
      });
    }
  }
  return i.sort(on);
}, nr = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const o = Wt(t), i = [];
  for (const s of r) {
    const {
      id: a
    } = s, l = n.get(a);
    if (l) {
      const c = Wt(l), d = o.reduce((h, f, p) => h + rn(c[p], f), 0), u = Number((d / 4).toFixed(4));
      i.push({
        id: a,
        data: {
          droppableContainer: s,
          value: u
        }
      });
    }
  }
  return i.sort(on);
};
function rr(e, t) {
  const n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), o = Math.min(t.left + t.width, e.left + e.width), i = Math.min(t.top + t.height, e.top + e.height), s = o - r, a = i - n;
  if (r < o && n < i) {
    const l = t.width * t.height, c = e.width * e.height, d = s * a, u = d / (l + c - d);
    return Number(u.toFixed(4));
  }
  return 0;
}
const or = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: r
  } = e;
  const o = [];
  for (const i of r) {
    const {
      id: s
    } = i, a = n.get(s);
    if (a) {
      const l = rr(a, t);
      l > 0 && o.push({
        id: s,
        data: {
          droppableContainer: i,
          value: l
        }
      });
    }
  }
  return o.sort(er);
};
function ir(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function an(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Q;
}
function sr(e) {
  return function(n) {
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return o.reduce((s, a) => ({
      ...s,
      top: s.top + e * a.y,
      bottom: s.bottom + e * a.y,
      left: s.left + e * a.x,
      right: s.right + e * a.x
    }), {
      ...n
    });
  };
}
const ar = /* @__PURE__ */ sr(1);
function lr(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function cr(e, t, n) {
  const r = lr(t);
  if (!r)
    return e;
  const {
    scaleX: o,
    scaleY: i,
    x: s,
    y: a
  } = r, l = e.left - s - (1 - o) * parseFloat(n), c = e.top - a - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), d = o ? e.width / o : e.width, u = i ? e.height / i : e.height;
  return {
    width: d,
    height: u,
    top: c,
    right: l + d,
    bottom: c + u,
    left: l
  };
}
const ur = {
  ignoreTransform: !1
};
function Ee(e, t) {
  t === void 0 && (t = ur);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: c,
      transformOrigin: d
    } = X(e).getComputedStyle(e);
    c && (n = cr(n, c, d));
  }
  const {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  } = n;
  return {
    top: r,
    left: o,
    width: i,
    height: s,
    bottom: a,
    right: l
  };
}
function Ut(e) {
  return Ee(e, {
    ignoreTransform: !0
  });
}
function dr(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function fr(e, t) {
  return t === void 0 && (t = X(e).getComputedStyle(e)), t.position === "fixed";
}
function hr(e, t) {
  t === void 0 && (t = X(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((o) => {
    const i = t[o];
    return typeof i == "string" ? n.test(i) : !1;
  });
}
function ct(e, t) {
  const n = [];
  function r(o) {
    if (t != null && n.length >= t || !o)
      return n;
    if (It(o) && o.scrollingElement != null && !n.includes(o.scrollingElement))
      return n.push(o.scrollingElement), n;
    if (!He(o) || en(o) || n.includes(o))
      return n;
    const i = X(e).getComputedStyle(o);
    return o !== e && hr(o, i) && n.push(o), fr(o, i) ? n : r(o.parentNode);
  }
  return e ? r(e) : n;
}
function ln(e) {
  const [t] = ct(e, 1);
  return t ?? null;
}
function bt(e) {
  return !lt || !e ? null : Re(e) ? e : Rt(e) ? It(e) || e === Ie(e).scrollingElement ? window : He(e) ? e : null : null;
}
function cn(e) {
  return Re(e) ? e.scrollX : e.scrollLeft;
}
function un(e) {
  return Re(e) ? e.scrollY : e.scrollTop;
}
function Dt(e) {
  return {
    x: cn(e),
    y: un(e)
  };
}
var k;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(k || (k = {}));
function dn(e) {
  return !lt || !e ? !1 : e === document.scrollingElement;
}
function fn(e) {
  const t = {
    x: 0,
    y: 0
  }, n = dn(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, r = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, o = e.scrollTop <= t.y, i = e.scrollLeft <= t.x, s = e.scrollTop >= r.y, a = e.scrollLeft >= r.x;
  return {
    isTop: o,
    isLeft: i,
    isBottom: s,
    isRight: a,
    maxScroll: r,
    minScroll: t
  };
}
const gr = {
  x: 0.2,
  y: 0.2
};
function vr(e, t, n, r, o) {
  let {
    top: i,
    left: s,
    right: a,
    bottom: l
  } = n;
  r === void 0 && (r = 10), o === void 0 && (o = gr);
  const {
    isTop: c,
    isBottom: d,
    isLeft: u,
    isRight: h
  } = fn(e), f = {
    x: 0,
    y: 0
  }, p = {
    x: 0,
    y: 0
  }, g = {
    height: t.height * o.y,
    width: t.width * o.x
  };
  return !c && i <= t.top + g.height ? (f.y = k.Backward, p.y = r * Math.abs((t.top + g.height - i) / g.height)) : !d && l >= t.bottom - g.height && (f.y = k.Forward, p.y = r * Math.abs((t.bottom - g.height - l) / g.height)), !h && a >= t.right - g.width ? (f.x = k.Forward, p.x = r * Math.abs((t.right - g.width - a) / g.width)) : !u && s <= t.left + g.width && (f.x = k.Backward, p.x = r * Math.abs((t.left + g.width - s) / g.width)), {
    direction: f,
    speed: p
  };
}
function pr(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: i,
      innerHeight: s
    } = window;
    return {
      top: 0,
      left: 0,
      right: i,
      bottom: s,
      width: i,
      height: s
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: o
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: o,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function hn(e) {
  return e.reduce((t, n) => Se(t, Dt(n)), Q);
}
function br(e) {
  return e.reduce((t, n) => t + cn(n), 0);
}
function mr(e) {
  return e.reduce((t, n) => t + un(n), 0);
}
function wr(e, t) {
  if (t === void 0 && (t = Ee), !e)
    return;
  const {
    top: n,
    left: r,
    bottom: o,
    right: i
  } = t(e);
  ln(e) && (o <= 0 || i <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const yr = [["x", ["left", "right"], br], ["y", ["top", "bottom"], mr]];
class Nt {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const r = ct(n), o = hn(r);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [i, s, a] of yr)
      for (const l of s)
        Object.defineProperty(this, l, {
          get: () => {
            const c = a(r), d = o[i] - c;
            return this.rect[l] + d;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Pe {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, r) {
    var o;
    (o = this.target) == null || o.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function xr(e) {
  const {
    EventTarget: t
  } = X(e);
  return e instanceof t ? e : Ie(e);
}
function mt(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var G;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(G || (G = {}));
function Ht(e) {
  e.preventDefault();
}
function Dr(e) {
  e.stopPropagation();
}
var w;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(w || (w = {}));
const gn = {
  start: [w.Space, w.Enter],
  cancel: [w.Esc],
  end: [w.Space, w.Enter, w.Tab]
}, Cr = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case w.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case w.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case w.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case w.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class Ot {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new Pe(Ie(n)), this.windowListeners = new Pe(X(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(G.Resize, this.handleCancel), this.windowListeners.add(G.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(G.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, r = t.node.current;
    r && wr(r), n(Q);
  }
  handleKeyDown(t) {
    if (At(t)) {
      const {
        active: n,
        context: r,
        options: o
      } = this.props, {
        keyboardCodes: i = gn,
        coordinateGetter: s = Cr,
        scrollBehavior: a = "smooth"
      } = o, {
        code: l
      } = t;
      if (i.end.includes(l)) {
        this.handleEnd(t);
        return;
      }
      if (i.cancel.includes(l)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: c
      } = r.current, d = c ? {
        x: c.left,
        y: c.top
      } : Q;
      this.referenceCoordinates || (this.referenceCoordinates = d);
      const u = s(t, {
        active: n,
        context: r.current,
        currentCoordinates: d
      });
      if (u) {
        const h = Xe(u, d), f = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: p
        } = r.current;
        for (const g of p) {
          const v = t.code, {
            isTop: b,
            isRight: y,
            isLeft: m,
            isBottom: C,
            maxScroll: S,
            minScroll: R
          } = fn(g), x = pr(g), D = {
            x: Math.min(v === w.Right ? x.right - x.width / 2 : x.right, Math.max(v === w.Right ? x.left : x.left + x.width / 2, u.x)),
            y: Math.min(v === w.Down ? x.bottom - x.height / 2 : x.bottom, Math.max(v === w.Down ? x.top : x.top + x.height / 2, u.y))
          }, T = v === w.Right && !y || v === w.Left && !m, L = v === w.Down && !C || v === w.Up && !b;
          if (T && D.x !== u.x) {
            const O = g.scrollLeft + h.x, J = v === w.Right && O <= S.x || v === w.Left && O >= R.x;
            if (J && !h.y) {
              g.scrollTo({
                left: O,
                behavior: a
              });
              return;
            }
            J ? f.x = g.scrollLeft - O : f.x = v === w.Right ? g.scrollLeft - S.x : g.scrollLeft - R.x, f.x && g.scrollBy({
              left: -f.x,
              behavior: a
            });
            break;
          } else if (L && D.y !== u.y) {
            const O = g.scrollTop + h.y, J = v === w.Down && O <= S.y || v === w.Up && O >= R.y;
            if (J && !h.x) {
              g.scrollTo({
                top: O,
                behavior: a
              });
              return;
            }
            J ? f.y = g.scrollTop - O : f.y = v === w.Down ? g.scrollTop - S.y : g.scrollTop - R.y, f.y && g.scrollBy({
              top: -f.y,
              behavior: a
            });
            break;
          }
        }
        this.handleMove(t, Se(Xe(u, this.referenceCoordinates), f));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
Ot.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: r = gn,
      onActivation: o
    } = t, {
      active: i
    } = n;
    const {
      code: s
    } = e.nativeEvent;
    if (r.start.includes(s)) {
      const a = i.activatorNode.current;
      return a && e.target !== a ? !1 : (e.preventDefault(), o?.({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function Kt(e) {
  return !!(e && "distance" in e);
}
function Vt(e) {
  return !!(e && "delay" in e);
}
class Tt {
  constructor(t, n, r) {
    var o;
    r === void 0 && (r = xr(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: i
    } = t, {
      target: s
    } = i;
    this.props = t, this.events = n, this.document = Ie(s), this.documentListeners = new Pe(this.document), this.listeners = new Pe(r), this.windowListeners = new Pe(X(s)), this.initialCoordinates = (o = xt(i)) != null ? o : Q, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: r
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(G.Resize, this.handleCancel), this.windowListeners.add(G.DragStart, Ht), this.windowListeners.add(G.VisibilityChange, this.handleCancel), this.windowListeners.add(G.ContextMenu, Ht), this.documentListeners.add(G.Keydown, this.handleKeydown), n) {
      if (r != null && r({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (Vt(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (Kt(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, n) {
    const {
      active: r,
      onPending: o
    } = this.props;
    o(r, t, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(G.Click, Dr, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(G.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: r,
      initialCoordinates: o,
      props: i
    } = this, {
      onMove: s,
      options: {
        activationConstraint: a
      }
    } = i;
    if (!o)
      return;
    const l = (n = xt(t)) != null ? n : Q, c = Xe(o, l);
    if (!r && a) {
      if (Kt(a)) {
        if (a.tolerance != null && mt(c, a.tolerance))
          return this.handleCancel();
        if (mt(c, a.distance))
          return this.handleStart();
      }
      if (Vt(a) && mt(c, a.tolerance))
        return this.handleCancel();
      this.handlePending(a, c);
      return;
    }
    t.cancelable && t.preventDefault(), s(l);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleKeydown(t) {
    t.code === w.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const Sr = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class vn extends Tt {
  constructor(t) {
    const {
      event: n
    } = t, r = Ie(n.target);
    super(t, Sr, r);
  }
}
vn.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
const Rr = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Ct;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Ct || (Ct = {}));
class pn extends Tt {
  constructor(t) {
    super(t, Rr, Ie(t.event.target));
  }
}
pn.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    return n.button === Ct.RightClick ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
const wt = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class bn extends Tt {
  constructor(t) {
    super(t, wt);
  }
  static setup() {
    return window.addEventListener(wt.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(wt.move.name, t);
    };
    function t() {
    }
  }
}
bn.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: r
    } = t;
    const {
      touches: o
    } = n;
    return o.length > 1 ? !1 : (r?.({
      event: n
    }), !0);
  }
}];
var $e;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})($e || ($e = {}));
var st;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(st || (st = {}));
function Ir(e) {
  let {
    acceleration: t,
    activator: n = $e.Pointer,
    canScroll: r,
    draggingRect: o,
    enabled: i,
    interval: s = 5,
    order: a = st.TreeOrder,
    pointerCoordinates: l,
    scrollableAncestors: c,
    scrollableAncestorRects: d,
    delta: u,
    threshold: h
  } = e;
  const f = Ar({
    delta: u,
    disabled: !i
  }), [p, g] = jn(), v = A({
    x: 0,
    y: 0
  }), b = A({
    x: 0,
    y: 0
  }), y = E(() => {
    switch (n) {
      case $e.Pointer:
        return l ? {
          top: l.y,
          bottom: l.y,
          left: l.x,
          right: l.x
        } : null;
      case $e.DraggableRect:
        return o;
    }
  }, [n, o, l]), m = A(null), C = $(() => {
    const R = m.current;
    if (!R)
      return;
    const x = v.current.x * b.current.x, D = v.current.y * b.current.y;
    R.scrollBy(x, D);
  }, []), S = E(() => a === st.TreeOrder ? [...c].reverse() : c, [a, c]);
  N(
    () => {
      if (!i || !c.length || !y) {
        g();
        return;
      }
      for (const R of S) {
        if (r?.(R) === !1)
          continue;
        const x = c.indexOf(R), D = d[x];
        if (!D)
          continue;
        const {
          direction: T,
          speed: L
        } = vr(R, D, y, t, h);
        for (const O of ["x", "y"])
          f[O][T[O]] || (L[O] = 0, T[O] = 0);
        if (L.x > 0 || L.y > 0) {
          g(), m.current = R, p(C, s), v.current = L, b.current = T;
          return;
        }
      }
      v.current = {
        x: 0,
        y: 0
      }, b.current = {
        x: 0,
        y: 0
      }, g();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      C,
      r,
      g,
      i,
      s,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(y),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(f),
      p,
      c,
      S,
      d,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(h)
    ]
  );
}
const Er = {
  x: {
    [k.Backward]: !1,
    [k.Forward]: !1
  },
  y: {
    [k.Backward]: !1,
    [k.Forward]: !1
  }
};
function Ar(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const r = yt(t);
  return Ke((o) => {
    if (n || !r || !o)
      return Er;
    const i = {
      x: Math.sign(t.x - r.x),
      y: Math.sign(t.y - r.y)
    };
    return {
      x: {
        [k.Backward]: o.x[k.Backward] || i.x === -1,
        [k.Forward]: o.x[k.Forward] || i.x === 1
      },
      y: {
        [k.Backward]: o.y[k.Backward] || i.y === -1,
        [k.Forward]: o.y[k.Forward] || i.y === 1
      }
    };
  }, [n, t, r]);
}
function Nr(e, t) {
  const n = t != null ? e.get(t) : void 0, r = n ? n.node.current : null;
  return Ke((o) => {
    var i;
    return t == null ? null : (i = r ?? o) != null ? i : null;
  }, [r, t]);
}
function Or(e, t) {
  return E(() => e.reduce((n, r) => {
    const {
      sensor: o
    } = r, i = o.activators.map((s) => ({
      eventName: s.eventName,
      handler: t(s.handler, r)
    }));
    return [...n, ...i];
  }, []), [e, t]);
}
var Ye;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Ye || (Ye = {}));
var St;
(function(e) {
  e.Optimized = "optimized";
})(St || (St = {}));
const qt = /* @__PURE__ */ new Map();
function Tr(e, t) {
  let {
    dragging: n,
    dependencies: r,
    config: o
  } = t;
  const [i, s] = K(null), {
    frequency: a,
    measure: l,
    strategy: c
  } = o, d = A(e), u = v(), h = je(u), f = $(function(b) {
    b === void 0 && (b = []), !h.current && s((y) => y === null ? b : y.concat(b.filter((m) => !y.includes(m))));
  }, [h]), p = A(null), g = Ke((b) => {
    if (u && !n)
      return qt;
    if (!b || b === qt || d.current !== e || i != null) {
      const y = /* @__PURE__ */ new Map();
      for (let m of e) {
        if (!m)
          continue;
        if (i && i.length > 0 && !i.includes(m.id) && m.rect.current) {
          y.set(m.id, m.rect.current);
          continue;
        }
        const C = m.node.current, S = C ? new Nt(l(C), C) : null;
        m.rect.current = S, S && y.set(m.id, S);
      }
      return y;
    }
    return b;
  }, [e, i, n, u, l]);
  return N(() => {
    d.current = e;
  }, [e]), N(
    () => {
      u || f();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, u]
  ), N(
    () => {
      i && i.length > 0 && s(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(i)]
  ), N(
    () => {
      u || typeof a != "number" || p.current !== null || (p.current = setTimeout(() => {
        f(), p.current = null;
      }, a));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, u, f, ...r]
  ), {
    droppableRects: g,
    measureDroppableContainers: f,
    measuringScheduled: i != null
  };
  function v() {
    switch (c) {
      case Ye.Always:
        return !1;
      case Ye.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function mn(e, t) {
  return Ke((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function Mr(e, t) {
  return mn(e, t);
}
function Lr(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Et(t), o = E(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: i
    } = window;
    return new i(r);
  }, [r, n]);
  return N(() => () => o?.disconnect(), [o]), o;
}
function ut(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const r = Et(t), o = E(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: i
      } = window;
      return new i(r);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return N(() => () => o?.disconnect(), [o]), o;
}
function kr(e) {
  return new Nt(Ee(e), e);
}
function Gt(e, t, n) {
  t === void 0 && (t = kr);
  const [r, o] = K(null);
  function i() {
    o((l) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var c;
        return (c = l ?? n) != null ? c : null;
      }
      const d = t(e);
      return JSON.stringify(l) === JSON.stringify(d) ? l : d;
    });
  }
  const s = Lr({
    callback(l) {
      if (e)
        for (const c of l) {
          const {
            type: d,
            target: u
          } = c;
          if (d === "childList" && u instanceof HTMLElement && u.contains(e)) {
            i();
            break;
          }
        }
    }
  }), a = ut({
    callback: i
  });
  return re(() => {
    i(), e ? (a?.observe(e), s?.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (a?.disconnect(), s?.disconnect());
  }, [e]), r;
}
function zr(e) {
  const t = mn(e);
  return an(e, t);
}
const Jt = [];
function Br(e) {
  const t = A(e), n = Ke((r) => e ? r && r !== Jt && e && t.current && e.parentNode === t.current.parentNode ? r : ct(e) : Jt, [e]);
  return N(() => {
    t.current = e;
  }, [e]), n;
}
function Pr(e) {
  const [t, n] = K(null), r = A(e), o = $((i) => {
    const s = bt(i.target);
    s && n((a) => a ? (a.set(s, Dt(s)), new Map(a)) : null);
  }, []);
  return N(() => {
    const i = r.current;
    if (e !== i) {
      s(i);
      const a = e.map((l) => {
        const c = bt(l);
        return c ? (c.addEventListener("scroll", o, {
          passive: !0
        }), [c, Dt(c)]) : null;
      }).filter((l) => l != null);
      n(a.length ? new Map(a) : null), r.current = e;
    }
    return () => {
      s(e), s(i);
    };
    function s(a) {
      a.forEach((l) => {
        const c = bt(l);
        c?.removeEventListener("scroll", o);
      });
    }
  }, [o, e]), E(() => e.length ? t ? Array.from(t.values()).reduce((i, s) => Se(i, s), Q) : hn(e) : Q, [e, t]);
}
function _t(e, t) {
  t === void 0 && (t = []);
  const n = A(null);
  return N(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), N(() => {
    const r = e !== Q;
    r && !n.current && (n.current = e), !r && n.current && (n.current = null);
  }, [e]), n.current ? Xe(e, n.current) : Q;
}
function $r(e) {
  N(
    () => {
      if (!lt)
        return;
      const t = e.map((n) => {
        let {
          sensor: r
        } = n;
        return r.setup == null ? void 0 : r.setup();
      });
      return () => {
        for (const n of t)
          n?.();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function Fr(e, t) {
  return E(() => e.reduce((n, r) => {
    let {
      eventName: o,
      handler: i
    } = r;
    return n[o] = (s) => {
      i(s, t);
    }, n;
  }, {}), [e, t]);
}
function wn(e) {
  return E(() => e ? dr(e) : null, [e]);
}
const Qt = [];
function jr(e, t) {
  t === void 0 && (t = Ee);
  const [n] = e, r = wn(n ? X(n) : null), [o, i] = K(Qt);
  function s() {
    i(() => e.length ? e.map((l) => dn(l) ? r : new Nt(t(l), l)) : Qt);
  }
  const a = ut({
    callback: s
  });
  return re(() => {
    a?.disconnect(), s(), e.forEach((l) => a?.observe(l));
  }, [e]), o;
}
function Xr(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return He(t) ? t : e;
}
function Wr(e) {
  let {
    measure: t
  } = e;
  const [n, r] = K(null), o = $((c) => {
    for (const {
      target: d
    } of c)
      if (He(d)) {
        r((u) => {
          const h = t(d);
          return u ? {
            ...u,
            width: h.width,
            height: h.height
          } : h;
        });
        break;
      }
  }, [t]), i = ut({
    callback: o
  }), s = $((c) => {
    const d = Xr(c);
    i?.disconnect(), d && i?.observe(d), r(d ? t(d) : null);
  }, [t, i]), [a, l] = ot(s);
  return E(() => ({
    nodeRef: a,
    rect: n,
    setRef: l
  }), [n, a, l]);
}
const Yr = [{
  sensor: vn,
  options: {}
}, {
  sensor: Ot,
  options: {}
}], Ur = {
  current: {}
}, rt = {
  draggable: {
    measure: Ut
  },
  droppable: {
    measure: Ut,
    strategy: Ye.WhileDragging,
    frequency: St.Optimized
  },
  dragOverlay: {
    measure: Ee
  }
};
class Fe extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const Hr = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new Fe(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: it
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: rt,
  measureDroppableContainers: it,
  windowRect: null,
  measuringScheduled: !1
}, Kr = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: it,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: it
}, dt = /* @__PURE__ */ Ue(Kr), yn = /* @__PURE__ */ Ue(Hr);
function Vr() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new Fe()
    }
  };
}
function qr(e, t) {
  switch (t.type) {
    case M.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case M.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case M.DragEnd:
    case M.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case M.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, o = new Fe(e.droppable.containers);
      return o.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case M.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: o
      } = t, i = e.droppable.containers.get(n);
      if (!i || r !== i.key)
        return e;
      const s = new Fe(e.droppable.containers);
      return s.set(n, {
        ...i,
        disabled: o
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    case M.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const i = new Fe(e.droppable.containers);
      return i.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    default:
      return e;
  }
}
function Gr(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: r,
    draggableNodes: o
  } = be(dt), i = yt(r), s = yt(n?.id);
  return N(() => {
    if (!t && !r && i && s != null) {
      if (!At(i) || document.activeElement === i.target)
        return;
      const a = o.get(s);
      if (!a)
        return;
      const {
        activatorNode: l,
        node: c
      } = a;
      if (!l.current && !c.current)
        return;
      requestAnimationFrame(() => {
        for (const d of [l.current, c.current]) {
          if (!d)
            continue;
          const u = Yn(d);
          if (u) {
            u.focus();
            break;
          }
        }
      });
    }
  }, [r, t, o, s, i]), null;
}
function Jr(e, t) {
  let {
    transform: n,
    ...r
  } = t;
  return e != null && e.length ? e.reduce((o, i) => i({
    transform: o,
    ...r
  }), n) : n;
}
function _r(e) {
  return E(
    () => ({
      draggable: {
        ...rt.draggable,
        ...e?.draggable
      },
      droppable: {
        ...rt.droppable,
        ...e?.droppable
      },
      dragOverlay: {
        ...rt.dragOverlay,
        ...e?.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e?.draggable, e?.droppable, e?.dragOverlay]
  );
}
function Qr(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: r,
    config: o = !0
  } = e;
  const i = A(!1), {
    x: s,
    y: a
  } = typeof o == "boolean" ? {
    x: o,
    y: o
  } : o;
  re(() => {
    if (!s && !a || !t) {
      i.current = !1;
      return;
    }
    if (i.current || !r)
      return;
    const c = t?.node.current;
    if (!c || c.isConnected === !1)
      return;
    const d = n(c), u = an(d, r);
    if (s || (u.x = 0), a || (u.y = 0), i.current = !0, Math.abs(u.x) > 0 || Math.abs(u.y) > 0) {
      const h = ln(c);
      h && h.scrollBy({
        top: u.y,
        left: u.x
      });
    }
  }, [t, s, a, r, n]);
}
const xn = /* @__PURE__ */ Ue({
  ...Q,
  scaleX: 1,
  scaleY: 1
});
var ve;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(ve || (ve = {}));
const Zr = /* @__PURE__ */ Bn(function(t) {
  var n, r, o, i;
  let {
    id: s,
    accessibility: a,
    autoScroll: l = !0,
    children: c,
    sensors: d = Yr,
    collisionDetection: u = or,
    measuring: h,
    modifiers: f,
    ...p
  } = t;
  const g = Pn(qr, void 0, Vr), [v, b] = g, [y, m] = Gn(), [C, S] = K(ve.Uninitialized), R = C === ve.Initialized, {
    draggable: {
      active: x,
      nodes: D,
      translate: T
    },
    droppable: {
      containers: L
    }
  } = v, O = x != null ? D.get(x) : null, J = A({
    initial: null,
    translated: null
  }), _ = E(() => {
    var B;
    return x != null ? {
      id: x,
      // It's possible for the active node to unmount while dragging
      data: (B = O?.data) != null ? B : Ur,
      rect: J
    } : null;
  }, [x, O]), Z = A(null), [Ae, qe] = K(null), [W, Ge] = K(null), oe = je(p, Object.values(p)), Ne = Ve("DndDescribedBy", s), Je = E(() => L.getEnabled(), [L]), F = _r(h), {
    droppableRects: ie,
    measureDroppableContainers: pe,
    measuringScheduled: Oe
  } = Tr(Je, {
    dragging: R,
    dependencies: [T.x, T.y],
    config: F.droppable
  }), V = Nr(D, x), _e = E(() => W ? xt(W) : null, [W]), ce = kn(), se = Mr(V, F.draggable.measure);
  Qr({
    activeNode: x != null ? D.get(x) : null,
    config: ce.layoutShiftCompensation,
    initialRect: se,
    measure: F.draggable.measure
  });
  const I = Gt(V, F.draggable.measure, se), Te = Gt(V ? V.parentElement : null), ee = A({
    activatorEvent: null,
    active: null,
    activeNode: V,
    collisionRect: null,
    collisions: null,
    droppableRects: ie,
    draggableNodes: D,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: L,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), me = L.getNodeFor((n = ee.current.over) == null ? void 0 : n.id), ae = Wr({
    measure: F.dragOverlay.measure
  }), we = (r = ae.nodeRef.current) != null ? r : V, ye = R ? (o = ae.rect) != null ? o : I : null, Lt = !!(ae.nodeRef.current && ae.rect), kt = zr(Lt ? null : I), ft = wn(we ? X(we) : null), ue = Br(R ? me ?? V : null), Qe = jr(ue), Ze = Jr(f, {
    transform: {
      x: T.x - kt.x,
      y: T.y - kt.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: W,
    active: _,
    activeNodeRect: I,
    containerNodeRect: Te,
    draggingNodeRect: ye,
    over: ee.current.over,
    overlayNodeRect: ae.rect,
    scrollableAncestors: ue,
    scrollableAncestorRects: Qe,
    windowRect: ft
  }), zt = _e ? Se(_e, T) : null, Bt = Pr(ue), En = _t(Bt), An = _t(Bt, [I]), xe = Se(Ze, En), De = ye ? ar(ye, Ze) : null, Me = _ && De ? u({
    active: _,
    collisionRect: De,
    droppableRects: ie,
    droppableContainers: Je,
    pointerCoordinates: zt
  }) : null, Pt = sn(Me, "id"), [de, $t] = K(null), Nn = Lt ? Ze : Se(Ze, An), On = ir(Nn, (i = de?.rect) != null ? i : null, I), ht = A(null), Ft = $(
    (B, Y) => {
      let {
        sensor: U,
        options: fe
      } = Y;
      if (Z.current == null)
        return;
      const q = D.get(Z.current);
      if (!q)
        return;
      const H = B.nativeEvent, te = new U({
        active: Z.current,
        activeNode: q,
        event: H,
        options: fe,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: ee,
        onAbort(z) {
          if (!D.get(z))
            return;
          const {
            onDragAbort: ne
          } = oe.current, le = {
            id: z
          };
          ne?.(le), y({
            type: "onDragAbort",
            event: le
          });
        },
        onPending(z, he, ne, le) {
          if (!D.get(z))
            return;
          const {
            onDragPending: ke
          } = oe.current, ge = {
            id: z,
            constraint: he,
            initialCoordinates: ne,
            offset: le
          };
          ke?.(ge), y({
            type: "onDragPending",
            event: ge
          });
        },
        onStart(z) {
          const he = Z.current;
          if (he == null)
            return;
          const ne = D.get(he);
          if (!ne)
            return;
          const {
            onDragStart: le
          } = oe.current, Le = {
            activatorEvent: H,
            active: {
              id: he,
              data: ne.data,
              rect: J
            }
          };
          et(() => {
            le?.(Le), S(ve.Initializing), b({
              type: M.DragStart,
              initialCoordinates: z,
              active: he
            }), y({
              type: "onDragStart",
              event: Le
            }), qe(ht.current), Ge(H);
          });
        },
        onMove(z) {
          b({
            type: M.DragMove,
            coordinates: z
          });
        },
        onEnd: Ce(M.DragEnd),
        onCancel: Ce(M.DragCancel)
      });
      ht.current = te;
      function Ce(z) {
        return async function() {
          const {
            active: ne,
            collisions: le,
            over: Le,
            scrollAdjustedTranslate: ke
          } = ee.current;
          let ge = null;
          if (ne && ke) {
            const {
              cancelDrop: ze
            } = oe.current;
            ge = {
              activatorEvent: H,
              active: ne,
              collisions: le,
              delta: ke,
              over: Le
            }, z === M.DragEnd && typeof ze == "function" && await Promise.resolve(ze(ge)) && (z = M.DragCancel);
          }
          Z.current = null, et(() => {
            b({
              type: z
            }), S(ve.Uninitialized), $t(null), qe(null), Ge(null), ht.current = null;
            const ze = z === M.DragEnd ? "onDragEnd" : "onDragCancel";
            if (ge) {
              const gt = oe.current[ze];
              gt?.(ge), y({
                type: ze,
                event: ge
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [D]
  ), Tn = $((B, Y) => (U, fe) => {
    const q = U.nativeEvent, H = D.get(fe);
    if (
      // Another sensor is already instantiating
      Z.current !== null || // No active draggable
      !H || // Event has already been captured
      q.dndKit || q.defaultPrevented
    )
      return;
    const te = {
      active: H
    };
    B(U, Y.options, te) === !0 && (q.dndKit = {
      capturedBy: Y.sensor
    }, Z.current = fe, Ft(U, Y));
  }, [D, Ft]), jt = Or(d, Tn);
  $r(d), re(() => {
    I && C === ve.Initializing && S(ve.Initialized);
  }, [I, C]), N(
    () => {
      const {
        onDragMove: B
      } = oe.current, {
        active: Y,
        activatorEvent: U,
        collisions: fe,
        over: q
      } = ee.current;
      if (!Y || !U)
        return;
      const H = {
        active: Y,
        activatorEvent: U,
        collisions: fe,
        delta: {
          x: xe.x,
          y: xe.y
        },
        over: q
      };
      et(() => {
        B?.(H), y({
          type: "onDragMove",
          event: H
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [xe.x, xe.y]
  ), N(
    () => {
      const {
        active: B,
        activatorEvent: Y,
        collisions: U,
        droppableContainers: fe,
        scrollAdjustedTranslate: q
      } = ee.current;
      if (!B || Z.current == null || !Y || !q)
        return;
      const {
        onDragOver: H
      } = oe.current, te = fe.get(Pt), Ce = te && te.rect.current ? {
        id: te.id,
        rect: te.rect.current,
        data: te.data,
        disabled: te.disabled
      } : null, z = {
        active: B,
        activatorEvent: Y,
        collisions: U,
        delta: {
          x: q.x,
          y: q.y
        },
        over: Ce
      };
      et(() => {
        $t(Ce), H?.(z), y({
          type: "onDragOver",
          event: z
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Pt]
  ), re(() => {
    ee.current = {
      activatorEvent: W,
      active: _,
      activeNode: V,
      collisionRect: De,
      collisions: Me,
      droppableRects: ie,
      draggableNodes: D,
      draggingNode: we,
      draggingNodeRect: ye,
      droppableContainers: L,
      over: de,
      scrollableAncestors: ue,
      scrollAdjustedTranslate: xe
    }, J.current = {
      initial: ye,
      translated: De
    };
  }, [_, V, Me, De, D, we, ye, ie, L, de, ue, xe]), Ir({
    ...ce,
    delta: T,
    draggingRect: De,
    pointerCoordinates: zt,
    scrollableAncestors: ue,
    scrollableAncestorRects: Qe
  });
  const Mn = E(() => ({
    active: _,
    activeNode: V,
    activeNodeRect: I,
    activatorEvent: W,
    collisions: Me,
    containerNodeRect: Te,
    dragOverlay: ae,
    draggableNodes: D,
    droppableContainers: L,
    droppableRects: ie,
    over: de,
    measureDroppableContainers: pe,
    scrollableAncestors: ue,
    scrollableAncestorRects: Qe,
    measuringConfiguration: F,
    measuringScheduled: Oe,
    windowRect: ft
  }), [_, V, I, W, Me, Te, ae, D, L, ie, de, pe, ue, Qe, F, Oe, ft]), Ln = E(() => ({
    activatorEvent: W,
    activators: jt,
    active: _,
    activeNodeRect: I,
    ariaDescribedById: {
      draggable: Ne
    },
    dispatch: b,
    draggableNodes: D,
    over: de,
    measureDroppableContainers: pe
  }), [W, jt, _, I, b, Ne, D, de, pe]);
  return j.createElement(nn.Provider, {
    value: m
  }, j.createElement(dt.Provider, {
    value: Ln
  }, j.createElement(yn.Provider, {
    value: Mn
  }, j.createElement(xn.Provider, {
    value: On
  }, c)), j.createElement(Gr, {
    disabled: a?.restoreFocus === !1
  })), j.createElement(Qn, {
    ...a,
    hiddenTextDescribedById: Ne
  }));
  function kn() {
    const B = Ae?.autoScrollEnabled === !1, Y = typeof l == "object" ? l.enabled === !1 : l === !1, U = R && !B && !Y;
    return typeof l == "object" ? {
      ...l,
      enabled: U
    } : {
      enabled: U
    };
  }
}), eo = /* @__PURE__ */ Ue(null), Zt = "button", to = "Draggable";
function no(e) {
  let {
    id: t,
    data: n,
    disabled: r = !1,
    attributes: o
  } = e;
  const i = Ve(to), {
    activators: s,
    activatorEvent: a,
    active: l,
    activeNodeRect: c,
    ariaDescribedById: d,
    draggableNodes: u,
    over: h
  } = be(dt), {
    role: f = Zt,
    roleDescription: p = "draggable",
    tabIndex: g = 0
  } = o ?? {}, v = l?.id === t, b = be(v ? xn : eo), [y, m] = ot(), [C, S] = ot(), R = Fr(s, t), x = je(n);
  re(
    () => (u.set(t, {
      id: t,
      key: i,
      node: y,
      activatorNode: C,
      data: x
    }), () => {
      const T = u.get(t);
      T && T.key === i && u.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [u, t]
  );
  const D = E(() => ({
    role: f,
    tabIndex: g,
    "aria-disabled": r,
    "aria-pressed": v && f === Zt ? !0 : void 0,
    "aria-roledescription": p,
    "aria-describedby": d.draggable
  }), [r, f, g, v, p, d.draggable]);
  return {
    active: l,
    activatorEvent: a,
    activeNodeRect: c,
    attributes: D,
    isDragging: v,
    listeners: r ? void 0 : R,
    node: y,
    over: h,
    setNodeRef: m,
    setActivatorNodeRef: S,
    transform: b
  };
}
function ro() {
  return be(yn);
}
const oo = "Droppable", io = {
  timeout: 25
};
function so(e) {
  let {
    data: t,
    disabled: n = !1,
    id: r,
    resizeObserverConfig: o
  } = e;
  const i = Ve(oo), {
    active: s,
    dispatch: a,
    over: l,
    measureDroppableContainers: c
  } = be(dt), d = A({
    disabled: n
  }), u = A(!1), h = A(null), f = A(null), {
    disabled: p,
    updateMeasurementsFor: g,
    timeout: v
  } = {
    ...io,
    ...o
  }, b = je(g ?? r), y = $(
    () => {
      if (!u.current) {
        u.current = !0;
        return;
      }
      f.current != null && clearTimeout(f.current), f.current = setTimeout(() => {
        c(Array.isArray(b.current) ? b.current : [b.current]), f.current = null;
      }, v);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), m = ut({
    callback: y,
    disabled: p || !s
  }), C = $((D, T) => {
    m && (T && (m.unobserve(T), u.current = !1), D && m.observe(D));
  }, [m]), [S, R] = ot(C), x = je(t);
  return N(() => {
    !m || !S.current || (m.disconnect(), u.current = !1, m.observe(S.current));
  }, [S, m]), N(
    () => (a({
      type: M.RegisterDroppable,
      element: {
        id: r,
        key: i,
        disabled: n,
        node: S,
        rect: h,
        data: x
      }
    }), () => a({
      type: M.UnregisterDroppable,
      key: i,
      id: r
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r]
  ), N(() => {
    n !== d.current.disabled && (a({
      type: M.SetDroppableDisabled,
      id: r,
      key: i,
      disabled: n
    }), d.current.disabled = n);
  }, [r, i, n, a]), {
    active: s,
    rect: h,
    isOver: l?.id === r,
    node: S,
    over: l,
    setNodeRef: R
  };
}
function Mt(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function ao(e, t) {
  return e.reduce((n, r, o) => {
    const i = t.get(r);
    return i && (n[o] = i), n;
  }, Array(e.length));
}
function tt(e) {
  return e !== null && e >= 0;
}
function lo(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function co(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const Dn = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: r,
    index: o
  } = e;
  const i = Mt(t, r, n), s = t[o], a = i[o];
  return !a || !s ? null : {
    x: a.left - s.left,
    y: a.top - s.top,
    scaleX: a.width / s.width,
    scaleY: a.height / s.height
  };
}, nt = {
  scaleX: 1,
  scaleY: 1
}, uo = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: r,
    index: o,
    rects: i,
    overIndex: s
  } = e;
  const a = (t = i[n]) != null ? t : r;
  if (!a)
    return null;
  if (o === n) {
    const c = i[s];
    return c ? {
      x: 0,
      y: n < s ? c.top + c.height - (a.top + a.height) : c.top - a.top,
      ...nt
    } : null;
  }
  const l = fo(i, o, n);
  return o > n && o <= s ? {
    x: 0,
    y: -a.height - l,
    ...nt
  } : o < n && o >= s ? {
    x: 0,
    y: a.height + l,
    ...nt
  } : {
    x: 0,
    y: 0,
    ...nt
  };
};
function fo(e, t, n) {
  const r = e[t], o = e[t - 1], i = e[t + 1];
  return r ? n < t ? o ? r.top - (o.top + o.height) : i ? i.top - (r.top + r.height) : 0 : i ? i.top - (r.top + r.height) : o ? r.top - (o.top + o.height) : 0 : 0;
}
const Cn = "Sortable", Sn = /* @__PURE__ */ j.createContext({
  activeIndex: -1,
  containerId: Cn,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: Dn,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function ho(e) {
  let {
    children: t,
    id: n,
    items: r,
    strategy: o = Dn,
    disabled: i = !1
  } = e;
  const {
    active: s,
    dragOverlay: a,
    droppableRects: l,
    over: c,
    measureDroppableContainers: d
  } = ro(), u = Ve(Cn, n), h = a.rect !== null, f = E(() => r.map((R) => typeof R == "object" && "id" in R ? R.id : R), [r]), p = s != null, g = s ? f.indexOf(s.id) : -1, v = c ? f.indexOf(c.id) : -1, b = A(f), y = !lo(f, b.current), m = v !== -1 && g === -1 || y, C = co(i);
  re(() => {
    y && p && d(f);
  }, [y, f, p, d]), N(() => {
    b.current = f;
  }, [f]);
  const S = E(
    () => ({
      activeIndex: g,
      containerId: u,
      disabled: C,
      disableTransforms: m,
      items: f,
      overIndex: v,
      useDragOverlay: h,
      sortedRects: ao(f, l),
      strategy: o
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g, u, C.draggable, C.droppable, m, f, v, l, h, o]
  );
  return j.createElement(Sn.Provider, {
    value: S
  }, t);
}
const go = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: r,
    overIndex: o
  } = e;
  return Mt(n, r, o).indexOf(t);
}, vo = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: r,
    index: o,
    items: i,
    newIndex: s,
    previousItems: a,
    previousContainerId: l,
    transition: c
  } = e;
  return !c || !r || a !== i && o === s ? !1 : n ? !0 : s !== o && t === l;
}, po = {
  duration: 200,
  easing: "ease"
}, Rn = "transform", bo = /* @__PURE__ */ We.Transition.toString({
  property: Rn,
  duration: 0,
  easing: "linear"
}), mo = {
  roleDescription: "sortable"
};
function wo(e) {
  let {
    disabled: t,
    index: n,
    node: r,
    rect: o
  } = e;
  const [i, s] = K(null), a = A(n);
  return re(() => {
    if (!t && n !== a.current && r.current) {
      const l = o.current;
      if (l) {
        const c = Ee(r.current, {
          ignoreTransform: !0
        }), d = {
          x: l.left - c.left,
          y: l.top - c.top,
          scaleX: l.width / c.width,
          scaleY: l.height / c.height
        };
        (d.x || d.y) && s(d);
      }
    }
    n !== a.current && (a.current = n);
  }, [t, n, r, o]), N(() => {
    i && s(null);
  }, [i]), i;
}
function yo(e) {
  let {
    animateLayoutChanges: t = vo,
    attributes: n,
    disabled: r,
    data: o,
    getNewIndex: i = go,
    id: s,
    strategy: a,
    resizeObserverConfig: l,
    transition: c = po
  } = e;
  const {
    items: d,
    containerId: u,
    activeIndex: h,
    disabled: f,
    disableTransforms: p,
    sortedRects: g,
    overIndex: v,
    useDragOverlay: b,
    strategy: y
  } = be(Sn), m = xo(r, f), C = d.indexOf(s), S = E(() => ({
    sortable: {
      containerId: u,
      index: C,
      items: d
    },
    ...o
  }), [u, o, C, d]), R = E(() => d.slice(d.indexOf(s)), [d, s]), {
    rect: x,
    node: D,
    isOver: T,
    setNodeRef: L
  } = so({
    id: s,
    data: S,
    disabled: m.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: R,
      ...l
    }
  }), {
    active: O,
    activatorEvent: J,
    activeNodeRect: _,
    attributes: Z,
    setNodeRef: Ae,
    listeners: qe,
    isDragging: W,
    over: Ge,
    setActivatorNodeRef: oe,
    transform: Ne
  } = no({
    id: s,
    data: S,
    attributes: {
      ...mo,
      ...n
    },
    disabled: m.draggable
  }), Je = Fn(L, Ae), F = !!O, ie = F && !p && tt(h) && tt(v), pe = !b && W, Oe = pe && ie ? Ne : null, _e = ie ? Oe ?? (a ?? y)({
    rects: g,
    activeNodeRect: _,
    activeIndex: h,
    overIndex: v,
    index: C
  }) : null, ce = tt(h) && tt(v) ? i({
    id: s,
    items: d,
    activeIndex: h,
    overIndex: v
  }) : C, se = O?.id, I = A({
    activeId: se,
    items: d,
    newIndex: ce,
    containerId: u
  }), Te = d !== I.current.items, ee = t({
    active: O,
    containerId: u,
    isDragging: W,
    isSorting: F,
    id: s,
    index: C,
    items: d,
    newIndex: I.current.newIndex,
    previousItems: I.current.items,
    previousContainerId: I.current.containerId,
    transition: c,
    wasDragging: I.current.activeId != null
  }), me = wo({
    disabled: !ee,
    index: C,
    node: D,
    rect: x
  });
  return N(() => {
    F && I.current.newIndex !== ce && (I.current.newIndex = ce), u !== I.current.containerId && (I.current.containerId = u), d !== I.current.items && (I.current.items = d);
  }, [F, ce, u, d]), N(() => {
    if (se === I.current.activeId)
      return;
    if (se != null && I.current.activeId == null) {
      I.current.activeId = se;
      return;
    }
    const we = setTimeout(() => {
      I.current.activeId = se;
    }, 50);
    return () => clearTimeout(we);
  }, [se]), {
    active: O,
    activeIndex: h,
    attributes: Z,
    data: S,
    rect: x,
    index: C,
    newIndex: ce,
    items: d,
    isOver: T,
    isSorting: F,
    isDragging: W,
    listeners: qe,
    node: D,
    overIndex: v,
    over: Ge,
    setNodeRef: Je,
    setActivatorNodeRef: oe,
    setDroppableNodeRef: L,
    setDraggableNodeRef: Ae,
    transform: me ?? _e,
    transition: ae()
  };
  function ae() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      me || // Or to prevent items jumping to back to their "new" position when items change
      Te && I.current.newIndex === C
    )
      return bo;
    if (!(pe && !At(J) || !c) && (F || ee))
      return We.Transition.toString({
        ...c,
        property: Rn
      });
  }
}
function xo(e, t) {
  var n, r;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e?.draggable) != null ? n : t.draggable,
    droppable: (r = e?.droppable) != null ? r : t.droppable
  };
}
function at(e) {
  if (!e)
    return !1;
  const t = e.data.current;
  return !!(t && "sortable" in t && typeof t.sortable == "object" && "containerId" in t.sortable && "items" in t.sortable && "index" in t.sortable);
}
const Do = [w.Down, w.Right, w.Up, w.Left], Co = (e, t) => {
  let {
    context: {
      active: n,
      collisionRect: r,
      droppableRects: o,
      droppableContainers: i,
      over: s,
      scrollableAncestors: a
    }
  } = t;
  if (Do.includes(e.code)) {
    if (e.preventDefault(), !n || !r)
      return;
    const l = [];
    i.getEnabled().forEach((u) => {
      if (!u || u != null && u.disabled)
        return;
      const h = o.get(u.id);
      if (h)
        switch (e.code) {
          case w.Down:
            r.top < h.top && l.push(u);
            break;
          case w.Up:
            r.top > h.top && l.push(u);
            break;
          case w.Left:
            r.left > h.left && l.push(u);
            break;
          case w.Right:
            r.left < h.left && l.push(u);
            break;
        }
    });
    const c = nr({
      collisionRect: r,
      droppableRects: o,
      droppableContainers: l
    });
    let d = sn(c, "id");
    if (d === s?.id && c.length > 1 && (d = c[1].id), d != null) {
      const u = i.get(n.id), h = i.get(d), f = h ? o.get(h.id) : null, p = h?.node.current;
      if (p && f && u && h) {
        const v = ct(p).some((R, x) => a[x] !== R), b = In(u, h), y = So(u, h), m = v || !b ? {
          x: 0,
          y: 0
        } : {
          x: y ? r.width - f.width : 0,
          y: y ? r.height - f.height : 0
        }, C = {
          x: f.left,
          y: f.top
        };
        return m.x && m.y ? C : Xe(C, m);
      }
    }
  }
};
function In(e, t) {
  return !at(e) || !at(t) ? !1 : e.data.current.sortable.containerId === t.data.current.sortable.containerId;
}
function So(e, t) {
  return !at(e) || !at(t) || !In(e, t) ? !1 : e.data.current.sortable.index < t.data.current.sortable.index;
}
function Ro({
  itemId: e,
  index: t,
  title: n,
  subtitle: r,
  removable: o,
  canRemove: i,
  onRemove: s,
  disabled: a,
  testIds: l,
  trailing: c
}) {
  const { attributes: d, listeners: u, setNodeRef: h, transform: f, transition: p, isDragging: g } = yo({ id: e }), b = {
    ...{
      transform: We.Transform.toString(f),
      transition: p
    },
    WebkitUserSelect: "none",
    userSelect: "none",
    WebkitTouchCallout: "none"
  };
  return /* @__PURE__ */ Be(
    "div",
    {
      ref: h,
      style: b,
      "data-testid": l.row,
      "data-item-id": e,
      "data-dragging": g || void 0,
      className: `reorder-list-row flex items-center gap-2.5 py-2 px-2.5 rounded border bg-nim-secondary ${g ? "border-nim-primary shadow-lg" : "border-nim"}`,
      children: [
        /* @__PURE__ */ P(
          "button",
          {
            type: "button",
            ...d,
            ...u,
            disabled: a,
            "aria-label": "Drag to reorder",
            style: { touchAction: "none" },
            className: "w-5 h-5 shrink-0 text-nim-faint cursor-grab disabled:cursor-not-allowed flex items-center justify-center",
            children: /* @__PURE__ */ Be("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", children: [
              /* @__PURE__ */ P("circle", { cx: "5", cy: "3", r: "1", fill: "currentColor" }),
              /* @__PURE__ */ P("circle", { cx: "9", cy: "3", r: "1", fill: "currentColor" }),
              /* @__PURE__ */ P("circle", { cx: "5", cy: "7", r: "1", fill: "currentColor" }),
              /* @__PURE__ */ P("circle", { cx: "9", cy: "7", r: "1", fill: "currentColor" }),
              /* @__PURE__ */ P("circle", { cx: "5", cy: "11", r: "1", fill: "currentColor" }),
              /* @__PURE__ */ P("circle", { cx: "9", cy: "11", r: "1", fill: "currentColor" })
            ] })
          }
        ),
        /* @__PURE__ */ P("div", { className: "w-6 text-center text-xs font-semibold text-nim-muted font-mono shrink-0", children: t + 1 }),
        /* @__PURE__ */ Be("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ P("div", { className: "text-[0.8125rem] font-medium text-nim leading-snug", children: n }),
          r && /* @__PURE__ */ P("div", { className: "text-xs text-nim-muted leading-snug", children: r })
        ] }),
        c,
        o && /* @__PURE__ */ P(
          "button",
          {
            type: "button",
            "data-testid": l.remove,
            onClick: s,
            disabled: a || !i,
            "aria-label": "Remove item",
            className: "w-6 h-6 shrink-0 rounded text-nim-faint hover:text-nim-error hover:bg-[color-mix(in_srgb,var(--nim-error)_12%,transparent)] disabled:opacity-30 disabled:cursor-not-allowed flex items-center justify-center",
            children: /* @__PURE__ */ P("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", children: /* @__PURE__ */ P("path", { d: "M3 4h8M5 4V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1M4 4l.5 7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1L10 4", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }) })
          }
        )
      ]
    }
  );
}
const No = ({
  items: e,
  state: t,
  onChange: n,
  minItems: r,
  disabled: o = !1,
  rootClassName: i,
  testIds: s = {},
  renderTrailing: a
}) => {
  const l = Zn(
    pt(pn, { activationConstraint: { distance: 4 } }),
    pt(bn, { activationConstraint: { delay: 200, tolerance: 6 } }),
    pt(Ot, { coordinateGetter: Co })
  ), c = E(() => {
    const f = /* @__PURE__ */ new Map();
    for (const p of e) f.set(p.id, p);
    return f;
  }, [e]), d = Math.max(r ?? 0, 0), u = (f) => {
    const { active: p, over: g } = f;
    if (!g || p.id === g.id) return;
    const v = t.orderedIds.indexOf(String(p.id)), b = t.orderedIds.indexOf(String(g.id));
    v === -1 || b === -1 || n({
      orderedIds: Mt(t.orderedIds, v, b),
      removedIds: t.removedIds
    });
  }, h = (f) => {
    o || t.orderedIds.length <= d || n({
      orderedIds: t.orderedIds.filter((p) => p !== f),
      removedIds: [...t.removedIds, f]
    });
  };
  return /* @__PURE__ */ Be(
    "div",
    {
      "data-testid": s.root,
      className: `${i ? `${i} ` : ""}reorder-list flex flex-col gap-1.5`,
      children: [
        /* @__PURE__ */ P(Zr, { sensors: l, collisionDetection: tr, onDragEnd: u, children: /* @__PURE__ */ P(ho, { items: t.orderedIds, strategy: uo, children: t.orderedIds.map((f, p) => {
          const g = c.get(f);
          return g ? /* @__PURE__ */ P(
            Ro,
            {
              itemId: f,
              index: p,
              title: g.title,
              subtitle: g.subtitle,
              removable: g.removable === !0,
              canRemove: t.orderedIds.length > d,
              onRemove: () => h(f),
              disabled: o,
              testIds: s,
              trailing: a?.(f)
            },
            f
          ) : null;
        }) }) }),
        t.removedIds.length > 0 && /* @__PURE__ */ Be("div", { className: "text-[0.6875rem] text-nim-faint italic px-1", children: [
          "Removed: ",
          t.removedIds.length,
          " item",
          t.removedIds.length === 1 ? "" : "s"
        ] })
      ]
    }
  );
};
export {
  No as R
};
//# sourceMappingURL=ReorderList-DmGGgR8l.js.map
